// extracted by mini-css-extract-plugin
export var custom = "fc-logos-module--custom--2b97c";
export var item = "fc-logos-module--item--5eb40";
export var items = "fc-logos-module--items--d559b";
export var root = "fc-logos-module--root--31963";
export var title = "fc-logos-module--title--39092";